import type { WorkProduct } from '../../../../types/Work'
import type { WorkId } from '../../../../types/WorkId'
import type { WorkQuantity } from '../../../../types/WorkQuantity'

type DeleteWorkStart = {
  type: 'DELETE_WORK_START'
  workId: WorkId
}

type DeleteWork = {
  type: 'DELETE_WORK'
  workId: WorkId
}

type UpdateQuantities = {
  type: 'UPDATE_QUANTITIES'
  workId: WorkId
  quantities: WorkQuantity
  isPrimaryProject: boolean
}

type UpdateProduct = {
  type: 'UPDATE_PRODUCT'
  workId: WorkId
  productInfo: WorkProduct
}

type RestoreWork = {
  type: 'RESTORE_WORK'
  workId: WorkId
}

export type WorkDataAction = DeleteWorkStart | DeleteWork | UpdateQuantities | UpdateProduct | RestoreWork

export const deleteWork = (workId: WorkId): DeleteWork => {
  return {
    type: 'DELETE_WORK',
    workId: workId,
  }
}

export const deleteWorkStart = (workId: WorkId): DeleteWorkStart => {
  return {
    type: 'DELETE_WORK_START',
    workId: workId,
  }
}

export const updateQuantities = (workId: WorkId, newQuantities: WorkQuantity, isPrimaryProject: boolean): UpdateQuantities => {
  return {
    type: 'UPDATE_QUANTITIES',
    workId: workId,
    quantities: newQuantities,
    isPrimaryProject: isPrimaryProject,
  }
}

export const updateProduct = (workId: WorkId, newProductInfo: WorkProduct): UpdateProduct => {
  return {
    type: 'UPDATE_PRODUCT',
    workId: workId,
    productInfo: newProductInfo,
  }
}

export const restoreWork = (workId: WorkId): RestoreWork => {
  return {
    type: 'RESTORE_WORK',
    workId: workId,
  }
}
